import React, { useEffect } from "react";
import "./Legal.css";

const sections = [
  {
    number: "01",
    title: "Who We Are",
    content: [
      "ASCENCIO Group is a marketing agency specialising in growth strategies for Aesthetic Clinics across the UK and Ireland. We are committed to protecting your personal data and handling it responsibly.",
      "This Privacy Policy explains how we collect, use, store, and protect your personal information when you visit our website or engage with our services.",
    ],
  },
  {
    number: "02",
    title: "Information We Collect",
    content: ["We may collect the following types of personal information:"],
    list: [
      "Name, email address, and phone number submitted via contact or booking forms",
      "Business information such as clinic name and website URL",
      "Communication preferences and service interests",
      "Technical data including IP address, browser type, and pages visited",
      "Cookies and usage data to improve your experience on our website",
    ],
  },
  {
    number: "03",
    title: "How We Use Your Information",
    content: ["We use your personal information for the following purposes:"],
    list: [
      "To respond to enquiries and schedule consultation calls",
      "To deliver and manage our marketing services",
      "To send relevant updates, proposals, and service information",
      "To improve our website and understand how visitors interact with it",
      "To comply with legal obligations under UK GDPR and applicable law",
    ],
  },
  {
    number: "04",
    title: "Legal Basis for Processing",
    content: [
      "We process your personal data on the following legal grounds under UK GDPR:",
    ],
    list: [
      "Consent — when you submit a form or opt in to communications",
      "Contractual necessity — when processing is required to deliver our services",
      "Legitimate interests — to improve our services and communicate with prospects",
      "Legal obligation — when required by law or regulatory bodies",
    ],
  },
  {
    number: "05",
    title: "Data Retention",
    content: [
      "We retain your personal data only for as long as necessary to fulfil the purposes outlined in this policy, or as required by law. Client data is typically retained for 6 years in line with UK tax and business record requirements.",
      "You may request deletion of your data at any time by contacting us directly.",
    ],
  },
  {
    number: "06",
    title: "Data Sharing",
    content: [
      "We do not sell, rent, or trade your personal data. We may share information with trusted third-party service providers who assist in delivering our services, including CRM platforms, email tools, and analytics providers. All third parties are contractually obligated to protect your data.",
    ],
  },
  {
    number: "07",
    title: "Your Rights",
    content: ["Under UK GDPR, you have the following rights:"],
    list: [
      "Right to access — request a copy of your personal data",
      "Right to rectification — correct inaccurate or incomplete data",
      "Right to erasure — request deletion of your data",
      "Right to restrict processing — limit how we use your data",
      "Right to data portability — receive your data in a portable format",
      "Right to object — object to processing based on legitimate interests",
    ],
  },
  {
    number: "08",
    title: "Cookies",
    content: [
      "Our website uses cookies to enhance your browsing experience and analyse site traffic. You can control cookie settings through your browser. By continuing to use our site, you consent to our use of cookies.",
    ],
  },
  {
    number: "09",
    title: "Contact Us",
    content: [
      "If you have any questions about this Privacy Policy or wish to exercise your rights, please contact us:",
    ],
    highlight: {
      text: "Email: hello@ascencio.com | Address: London, UK",
      note: "We will respond to all requests within 30 days.",
    },
  },
];

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-page">
      <div className="legal-page__container">
        <div className="legal-page__badge">Legal</div>
        <h1 className="legal-page__title">Privacy Policy</h1>
        <p className="legal-page__updated">Last updated: February 2025</p>

        <div className="legal-page__content">
          {sections.map((section, index) => (
            <div key={index} className="legal-section">
              <div className="legal-section__number">{section.number}</div>
              <h2 className="legal-section__title">{section.title}</h2>
              {section.content.map((text, i) => (
                <p key={i} className="legal-section__text">
                  {text}
                </p>
              ))}
              {section.list && (
                <ul className="legal-section__list">
                  {section.list.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              )}
              {section.highlight && (
                <div className="legal-section__highlight">
                  <p>
                    <strong>{section.highlight.text}</strong>
                    <br />
                    {section.highlight.note}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
